const organizations = {
    title: '組織',
    description: '建立和管理你所屬的組織。',
    create: '建立組織',
    create_title: '建立新組織',
    name: '組織名稱',
    avatar: '組織頭像',
    avatar_removed: '組織頭像已移除。',
    description_label: '描述',
    empty: '你尚未加入任何組織。',
    pending_invitations: '待處理邀請',
    accept: '接受',
    decline: '拒絕',
    owner: '擁有者',
    tabs: {
        overview: '概覽',
        members: '成員',
        invitations: '邀請',
        roles: '管理角色',
        branding: '品牌',
        security: '安全性',
        jit: '即時佈建',
        applications: '共用資源',
        activity: '活動',
        deletion: '刪除',
    },
    members: {
        title: '成員',
        empty: '尚無成員。',
        remove: '移除',
        removed: '成員已移除。',
        business_roles: '業務角色',
        no_business_roles: '沒有可用的業務角色，請聯絡租戶管理員為此組織開放角色。',
    },
    invitations: {
        title: '邀請',
        invite: '邀請成員',
        email: '電子郵件地址',
        empty: '尚無邀請。',
        resend: '重新傳送',
        resent: '邀請已重新傳送。',
        revoke: '撤銷',
        revoked: '邀請已撤銷。',
        status: {
            Pending: '待接受',
            Accepted: '已接受',
            Expired: '已過期',
            Revoked: '已撤銷',
            Declined: '已拒絕',
        },
    },
    roles: {
        title: '管理角色',
        create: '建立角色',
        permissions: '權限',
        empty: '尚無管理角色。',
        select_member: '選擇成員',
        select_role: '選擇角色',
        assign: '指派角色',
        assigned: '角色已指派。',
        unassign: '移除角色',
        unassigned: '角色已移除。',
        permission_count: '權限數：{{count}}',
        built_in: {
            owner: '擁有者',
            owner_description: '擁有組織擁有權管理和刪除組織的專屬權限。',
            administrator: '管理員',
            administrator_description: '可管理組織，但不包括僅限擁有者的操作。',
        },
        permission_labels: {
            update_profile: '更新組織資料',
            manage_branding: '管理品牌',
            view_members: '檢視成員',
            manage_members: '管理成員',
            manage_invitations: '管理邀請',
            assign_business_roles: '指派業務角色',
            manage_management_roles: '設定管理角色',
            assign_management_roles: '指派管理角色',
            manage_security: '管理安全性設定',
            manage_jit: '管理即時佈建',
            manage_applications: '管理應用程式',
            view_activity: '檢視活動',
        },
    },
    branding: {
        title: '組織品牌',
        primary_color: '主色',
        custom_css: '自訂階層式樣式表（CSS）',
        preview: '預覽',
        light: '淺色',
        dark: '深色',
    },
    security: {
        title: '組織安全性',
        require_mfa: '要求成員使用多因素驗證',
    },
    jit: {
        title: '即時佈建電子郵件網域',
        domain: '電子郵件網域',
        add: '新增網域',
        verify: '檢查網域名稱系統（DNS）',
        dns_instruction: '建立 TXT 文字記錄 {{record}}，值為 {{value}}。',
        verified: '已驗證',
    },
    applications: {
        title: '共用資源',
        empty: '此組織尚無可用資源。',
        sso: '企業單一登入連線',
        m2m: '機器對機器應用程式',
    },
    activity: {
        title: '組織活動',
        empty: '尚無活動。',
        events: {
            create: '建立組織',
            delete: '刪除組織',
            profile: '更新組織資料',
            branding: '更新組織品牌',
            security: '更新組織安全性設定',
            member_add: '新增成員',
            member_remove: '移除成員',
            owner: '變更組織擁有者',
            role_create: '建立管理角色',
            role_update: '更新管理角色',
            role_delete: '刪除管理角色',
            role_assign: '指派管理角色',
            role_unassign: '移除成員的管理角色',
            business_role: '更新業務角色',
            invitation_create: '傳送邀請',
            invitation_accept: '接受邀請',
            invitation_decline: '拒絕邀請',
            invitation_revoke: '撤銷邀請',
            jit: '更新即時佈建設定',
            domain: '驗證電子郵件網域',
            application: '更新應用程式關聯',
            unknown: '組織活動',
        },
    },
    save: '儲存變更',
    cancel: '取消',
    delete: '刪除組織',
    delete_confirmation: '此操作會永久刪除組織及其成員關係。請輸入「{{name}}」確認。',
    deleted: '組織已刪除。',
    load_failed: '無法載入組織資料，請重試。',
    permission_denied: '你沒有權限檢視此頁面。',
};
export default organizations;
